// extracted by mini-css-extract-plugin
export var messageSideLeft = "_h7-1";
export var messageSideRight = "_h7-2";
export var subscribeToBackInStockBubbleContainer = "_h7-0";